export const ADMIN_USER_LIST_PATH = '/admin/users';
